// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Mjph1","subheader":"ReorderModal_subheader__2fzUP","listWrap":"ReorderModal_listWrap__2ssPt"};